webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(243),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b37355a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_admin_illustrations_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_admin_illustrations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_admin_illustrations_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_admin_illustration_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_admin_illustration_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_admin_illustration_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_admin_copies_vue__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_admin_copies_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_admin_copies_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_admin_copy_vue__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_admin_copy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_admin_copy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_public_copies_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_public_copies_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_public_copies_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_login_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_login_vue__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }, {
    path: '/admin/illustrations',
    name: 'AdminIllustrations',
    component: __WEBPACK_IMPORTED_MODULE_3__components_admin_admin_illustrations_vue___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/admin/illustration/:slug',
    name: 'AdminIllustration',
    component: __WEBPACK_IMPORTED_MODULE_4__components_admin_admin_illustration_vue___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/admin/illustration',
    name: 'AdminNewIllustration',
    component: __WEBPACK_IMPORTED_MODULE_4__components_admin_admin_illustration_vue___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/admin/copies',
    name: 'AdminCopies',
    component: __WEBPACK_IMPORTED_MODULE_5__components_admin_admin_copies_vue___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/admin/copy/:id',
    name: 'AdminCopy',
    component: __WEBPACK_IMPORTED_MODULE_6__components_admin_admin_copy_vue___default.a,
    meta: { requiresAuth: true }
  },, {
    path: '/copies',
    name: 'Copies',
    component: __WEBPACK_IMPORTED_MODULE_7__components_public_copies_vue___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/login/:returnpath',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_8__components_login_vue___default.a
  }, {
    path: '*',
    name: 'DefaultPath',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }]
}));
/*
this.$Router.beforeEach((to, from, next) => {

} );
*/

/***/ }),
/* 50 */,
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(213)
  __webpack_require__(212)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(247),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__(101);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__(106);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(134);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(153);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(156);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navbar_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__navbar_vue__);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {};
  },

  components: {
    'navbar': __WEBPACK_IMPORTED_MODULE_0__navbar_vue___default.a
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_navbar_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin-copies',
  data: function data() {
    return {
      copies: []
    };
  },

  methods: {
    // Load employee-data form webserivce
    loaddata: function loaddata() {
      this.$http.post('pCopyList').then(function (response) {
        this.copies = response.data;
      });
    },
    open: function open(id) {
      this.$router.push({ name: "AdminCopy", params: { id: id } });
    },
    newcopy: function newcopy() {
      this.$router.push({ name: "AdminNewCopy" });
    }
  },
  components: {
    'navbar': __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue___default.a
  },
  created: function created() {
    this.loaddata();
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_navbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_edit_full_width_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_edit_full_width_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_edit_full_width_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_quill_editor__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_popup_vue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_popup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_layout_popup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_confirm_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_confirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_layout_confirm_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin-copy',
  components: {
    'navbar': __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue___default.a,
    'Multiselect': __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a,
    'edit-full-width': __WEBPACK_IMPORTED_MODULE_2__components_layout_edit_full_width_vue___default.a,
    'VueEditor': __WEBPACK_IMPORTED_MODULE_3_vue2_quill_editor__["VueEditor"],
    'Popup': __WEBPACK_IMPORTED_MODULE_4__components_layout_popup_vue___default.a,
    'Confirm': __WEBPACK_IMPORTED_MODULE_5__components_layout_confirm_vue___default.a
  },
  data: function data() {
    return {
      copy: null,
      editions: [],
      locations: [],
      userstraces: [],
      userstracetypes: [],
      consulted: [],
      languages: [],
      dates: [],
      customToolbar: [['bold', 'italic', 'underline'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['image']],
      saved: 0,
      saving: false
    };
  },

  methods: {
    loadcopy: function loadcopy() {
      var data = {
        Id: this.$route.params.id
      };
      this.$http.post('x/pCopyDetails', data).then(function (response) {
        this.copy = response.data.Copy;this.saving = false;
      });
    },
    loaddata: function loaddata() {
      this.loadcopy();
      this.$http.post('pLookup', { "LookupName": "Edition" }).then(function (response) {
        this.editions = response.data;
      });
      this.$http.post('pLookup', { "LookupName": "Location" }).then(function (response) {
        this.locations = response.data;
      });
      this.$http.post('pLookup', { "LookupName": "Userstrace" }).then(function (response) {
        this.userstraces = response.data;
      });
      this.$http.post('pLookup', { "LookupName": "Consulted" }).then(function (response) {
        this.consulted = response.data;
      });
      this.$http.post('pLookup', { "LookupName": "Language" }).then(function (response) {
        this.languages = response.data;
      });
      this.$http.post('pLookup', { "LookupName": "UserstraceDate" }).then(function (response) {
        this.dates = response.data;
      });
      this.$http.post('pLookup', { "LookupName": "UsersTraceType" }).then(function (response) {
        this.userstracetypes = response.data;
      });
    },
    save: function save(close) {
      this.saving = true;
      this.$http.post('x/pCopySave', { "Copy": this.copy }).then(function (response) {
        if (close == true) {
          this.$router.push({ name: "AdminCopies" });
        } else {
          this.saved = 3;
          // Reload na saven
          this.loadcopy();
        }
      });
    },

    cancel: function cancel() {
      this.$router.push({ name: "AdminCopies" });
    },
    editUsersTrace: function editUsersTrace(cut) {
      this.$refs.popupUsersTrace.show(cut, this.copy.Userstraces.Items, this.$validator, this.errors);
    },
    deleteUsersTrace: function deleteUsersTrace(cut) {
      var data = this;
      this.$refs.confirmdialog.confirm("Delete Users Trace?", function () {
        var i = data.copy.Userstraces.Items.indexOf(cut);
        if (i != -1) data.copy.Userstraces.Items.splice(i, 1);
      });
    },
    addUsersTrace: function addUsersTrace() {
      this.$refs.popupUsersTrace.show({ Explanation: "" }, this.copy.Userstraces.Items, this.$validator, this.errors);
    },
    beforeSaveUsersTrace: function beforeSaveUsersTrace() {
      var data = this.$refs.popupUsersTrace.getData();
      data.UsersTrace = this.getByValue(this.userstraces, data.UsersTraceId);
      data.UsersTraceType = this.getByValue(this.userstracetypes, data.UsersTraceTypeId);
      data.ExplanationShort = data.Explanation && data.Explanation.length > 20 ? data.Explanation.substring(0, 20) : data.Explanation;
    },
    editLink: function editLink() {},
    deleteLink: function deleteLink() {},
    addLink: function addLink() {},
    getByValue: function getByValue(arr, value) {
      var result = arr.filter(function (o) {
        return o.Key == value;
      });
      return result ? result[0].Value : null;
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.saved = dismissCountDown;
    }
  },
  created: function created() {
    this.loaddata();
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_navbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin-illustration',
  data: function data() {
    return {
      illustration: null,
      sizes: [],
      shapes: [],
      compositiontypes: [],
      iconclasses: [],
      selectediconclasses: []
    };
  },

  methods: {
    // Load employee-data form webserivce
    loaddata: function loaddata() {
      var data = {
        Slug: this.$route.params.slug
      };
      this.$http.post('x/pIllustrationDetails', data).then(function (response) {
        this.illustration = response.data.Illustration;
      });
      this.$http.post('pLookup', { "LookupName": "Size" }).then(function (response) {
        this.sizes = response.data;
      });
      this.$http.post('pLookup', { "LookupName": "Shape" }).then(function (response) {
        this.shapes = response.data;
      });
      this.$http.post('pLookup', { "LookupName": "CompositionType" }).then(function (response) {
        this.compositiontypes = response.data;
      });
      this.$http.post('pLookup', { "LookupName": "Iconclass" }).then(function (response) {
        this.iconclasses = response.data;
      });
    },
    addTag: function addTag(newTag) {
      var tag = {
        Key: newTag,
        Value: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.illustration.IconClasses.Items.push(tag);
      this.selectediconclasses.push(tag);
    },

    save: function save() {
      this.$http.post('x/pIllustrationSave', { "Illustration": this.illustration }).then(function (response) {
        this.$router.push({ name: "AdminIllustrations" });
      });
    },

    cancel: function cancel() {
      this.$router.push({ name: "AdminIllustrations" });
    }
  },
  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
  },
  created: function created() {
    this.loaddata();
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_navbar_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin-illustrations',
  data: function data() {
    return {
      illustrations: []
    };
  },

  methods: {
    // Load employee-data form webserivce
    loaddata: function loaddata() {
      this.$http.post('pIllustrationList').then(function (response) {
        this.illustrations = response.data;
      });
    },
    open: function open(slug) {
      this.$router.push({ name: "AdminIllustration", params: { slug: slug } });
    },
    newillustration: function newillustration() {
      this.$router.push({ name: "AdminNewIllustration" });
    }
  },
  components: {
    'navbar': __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue___default.a
  },
  created: function created() {
    this.loaddata();
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'confirm',
	props: [],
	data: function data() {
		return {
			message: null,
			showmodal: false,
			callbackfunction: null
		};
	},

	methods: {
		onclick: function onclick() {
			if (this.callbackfunction != null) this.callbackfunction();
		},
		confirm: function confirm(msg, callback) {
			this.showmodal = true;
			this.message = msg;
			this.callbackfunction = callback;
		}
	}
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'edit-full-width',
  data: function data() {
    return {};
  },

  methods: {},
  components: {},
  props: ['caption', 'required'],
  created: function created() {}
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'popup',
	props: ['titel', 'okclick', 'data-vv-scope'],
	data: function data() {
		return {
			data: null,
			srcdata: null,
			collection: [],
			isnew: false,
			err: null,
			validator: null
		};
	},

	methods: {
		onclick: function onclick(e) {
			this.validator.validateAll(this.dataVvScope);
			if (!this.err.any(this.dataVvScope)) {
				this.$emit('okclick');
				this.updateCollection();
				this.close();
			} else {
				e.cancel();
			}
		},
		cancelclick: function cancelclick(e) {
			debugger;
			this.err.clear(this.dataVvScope);
		},
		show: function show(data, collection, validator, errors) {
			this.err = errors;
			this.validator = validator;
			this.err.clear(this.dataVvScope);
			// Data is een deep-copy van oorspronkelijke record. Deze ga je editten zodat de oorspronkelijke data ongewijzigd blijft voor het geval van cancel.
			this.data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
			// Srcdata is het oorspronkelijke record
			this.srcdata = data;

			this.isnew = collection.indexOf(data) == -1;
			this.collection = collection;
			this.$refs.modalPopup.show();
		},
		close: function close(e) {
			this.$refs.modalPopup.hide();
		},
		getData: function getData() {
			return this.data;
		},
		updateCollection: function updateCollection() {
			if (this.isnew) {
				// Add
				this.collection.push(this.data);
			} else {
				// Edit
				var index = this.collection.indexOf(this.srcdata);
				this.collection.splice(index, 1, JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data)));
			}
		}
	}
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navbar_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__navbar_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      credentials: {
        username: "",
        password: ""
      },
      loginfailed: false,
      Remember: false
    };
  },

  methods: {
    login: function login() {
      this.$http.post('pLoginUser', this.credentials).then(function (response) {
        if (response.data[0].Token == null || response.data[0].Token == "") {
          this.loginfailed = true;
          if (this.Remember) window.localStorage.setItem('authUser', null);else window.sessionStorage.setItem('authUser', null);
        } else {
          __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.headers.common['Authorization'] = 'Basic ' + btoa(this.credentials.username + ":" + this.credentials.password);
          this.loginfailed = false;
          if (this.Remember) window.localStorage.setItem('authUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.credentials));else window.sessionStorage.setItem('authUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.credentials));
          var url = this.$route.params.returnpath;
          this.$router.push({ path: url });
        }
      });
    }
  },
  created: function created() {
    var lsUser = JSON.parse(window.localStorage.getItem('authUser'));
    if (lsUser) {
      this.Remember = true;
      this.credentials.username = lsUser.username;
      this.credentials.password = lsUser.password;
      this.login();
    } else {
      var ssUser = JSON.parse(window.sessionStorage.getItem('authUser'));
      this.credentials.username = ssUser.username;
      this.credentials.password = ssUser.password;
      this.login();
    };
  },
  components: {
    'navbar': __WEBPACK_IMPORTED_MODULE_2__navbar_vue___default.a
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navbar',
  data: function data() {
    return {
      page: "home"
    };
  },

  methods: {
    logout: function logout() {
      window.localStorage.setItem('authUser', null);
      this.$router.push({ name: "Hello" });
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_navbar_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'copies',
  data: function data() {
    return {
      copies: []
    };
  },

  methods: {
    // Load employee-data form webserivce
    loaddata: function loaddata() {
      this.$http.post('pCopyList').then(function (response) {
        this.copies = response.data;
      });
    },
    open: function open(slug) {
      this.$router.push({ name: "Copy", params: { slug: slug } });
    }
  },
  components: {
    'navbar': __WEBPACK_IMPORTED_MODULE_0__components_navbar_vue___default.a
  },
  created: function created() {
    this.loaddata();
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(53);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

if (false) Vue.http.options.root = "http://dev.netherlandish-woodcuts.nl/sprocserv/api/Sproc/12345";else __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.root = "https://netherlandish-woodcuts.nl/api/api/Sproc/12345";

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
	if (to.meta.requiresAuth) {
		// Authenticatie nodig

		var auth = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.headers.common['Authorization'];
		if (auth) {
			// Ingelogd
			next();
		} else {
			// Nog niet ingelogd
			// zijn er authenticatiegegevens opgeslagen?
			var lsUser = JSON.parse(window.localStorage.getItem('authUser'));
			if (!lsUser) // Misschien in session storage dan?
				lsUser = JSON.parse(window.sessionStorage.getItem('authUser'));
			if (lsUser) {
				var credentials = { username: lsUser.username, password: lsUser.password };
				__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('pLoginUser', credentials).then(function (response) {
					if (response.data[0].Token != null && response.data[0].Token != "") {
						// Inloggen gelukt => door naar gevraagde scherm
						__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.headers.common['Authorization'] = 'Basic ' + btoa(credentials.username + ":" + credentials.password);
						next();
					} else {
						// Geen inloggegevens aanwezig of inloggen mislukt => naar loginscherm
						next({ name: "login", params: { returnpath: to.path } });
					}
				});
			} else {
				// Geen inloggegevens aanwezig of inloggen mislukt => naar loginscherm
				next({ name: "login", params: { returnpath: to.path } });
			}
		}
	} else {
		// Geen authenicatie nodig
		next();
	}
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(203)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(56),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(209)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(57),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(58),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(210)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(59),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(208)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(60),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(206)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(244),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b59a558",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(200)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(239),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-041d739b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(250),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e2fc9186",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(241),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0aa350d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(211)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(246),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ec83c8b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(214)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(248),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-790382b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(242),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17c67e10",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(215)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(249),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-89b03c5e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(240),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0619388f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(207)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(245),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3101c05f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-copies"
  }, [_c('navbar'), _vm._v(" "), _c('h2', [_vm._v("Admin Copies (" + _vm._s(_vm.copies.length) + ")")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.copies), function(copy) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(copy.Text))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(copy.Location))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(copy.Signature))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(copy.NumberOfUserstraces))]), _vm._v(" "), _c('td', [_c('b-button', {
      on: {
        "click": function($event) {
          _vm.open(copy.Id)
        }
      }
    }, [_vm._v("Edit")])], 1)])
  }))]), _vm._v(" "), _c('b-button', {
    on: {
      "click": function($event) {
        _vm.newcopy()
      }
    }
  }, [_vm._v("Add")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Text")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Signature")]), _vm._v(" "), _c('th', [_vm._v("#UT")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('navbar'), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "20rem"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Please sign in")]), _vm._v(" "), _c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputEmail",
      "placeholder": "Email address",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Remember),
      expression: "Remember"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "checkbox",
      "id": "rememberpassword"
    },
    domProps: {
      "checked": Array.isArray(_vm.Remember) ? _vm._i(_vm.Remember, null) > -1 : (_vm.Remember)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.Remember = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.Remember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.Remember = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rememberpassword"
    }
  }, [_vm._v("Remember password")]), _vm._v(" "), _c('div', [(_vm.loginfailed) ? _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v("Login failed")]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Sign in")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.illustration) ? _c('div', {
    staticClass: "admin-illustration"
  }, [_c('navbar'), _vm._v(" "), _c('h2', [_vm._v("Edit Illustration \"" + _vm._s(_vm.illustration.Subject) + "\"")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-md-6"
  }, [_c('p'), _vm._v(" "), _c('h5', [_vm._v("Subject")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Subject"
    },
    model: {
      value: (_vm.illustration.Subject),
      callback: function($$v) {
        _vm.$set(_vm.illustration, "Subject", $$v)
      },
      expression: "illustration.Subject"
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('h5', [_vm._v("Slug")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Slug"
    },
    model: {
      value: (_vm.illustration.Slug),
      callback: function($$v) {
        _vm.$set(_vm.illustration, "Slug", $$v)
      },
      expression: "illustration.Slug"
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('h5', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "textarea": "",
      "placeholder": "Remarks"
    },
    model: {
      value: (_vm.illustration.Remarks),
      callback: function($$v) {
        _vm.$set(_vm.illustration, "Remarks", $$v)
      },
      expression: "illustration.Remarks"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "col-md-6"
  }, [_c('p'), _vm._v(" "), _c('h5', [_vm._v("Shape")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.illustration.ShapeId),
      expression: "illustration.ShapeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.illustration, "ShapeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.shapes), function(s) {
    return _c('option', {
      domProps: {
        "value": s.Key
      }
    }, [_vm._v(_vm._s(s.Value))])
  })), _vm._v(" "), _c('p'), _vm._v(" "), _c('h5', [_vm._v("Composition Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.illustration.CompositionTypeId),
      expression: "illustration.CompositionTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.illustration, "CompositionTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.shapes), function(s) {
    return _c('option', {
      domProps: {
        "value": s.Key
      }
    }, [_vm._v(_vm._s(s.Value))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-md-12"
  }, [_c('p'), _vm._v(" "), _c('h5', [_vm._v("Icon Classes")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "Add this as new tag",
      "placeholder": "Search or add a tag",
      "label": "Value",
      "track-by": "Key",
      "options": _vm.iconclasses,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.illustration.IconClasses.Items),
      callback: function($$v) {
        _vm.$set(_vm.illustration.IconClasses, "Items", $$v)
      },
      expression: "illustration.IconClasses.Items"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-md-12"
  }, [_c('p'), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("Opslaan, Juffie")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Annuleren")])], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row efw"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('h5', [_vm._v(_vm._s(_vm.caption)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required),
      expression: "required"
    }]
  }, [_vm._v("*")])]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    attrs: {
      "toggleable": "",
      "type": "light",
      "variant": "faded",
      "toggle-breakpoint": "md"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'Hello'
      }
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Illustrations")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Editions")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'Copies'
      }
    }
  }, [_vm._v("Copies")])], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": "Admin",
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'AdminIllustrations'
      }
    }
  }, [_vm._v("Illustrations")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'AdminCopies'
      }
    }
  }, [_vm._v("Copies")])], 1), _vm._v(" "), _c('b-nav-form', [_c('b-form-input', {
    staticClass: "mr-sm-2",
    attrs: {
      "size": "sm",
      "type": "text",
      "placeholder": "Search"
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "my-2 my-sm-0",
    attrs: {
      "size": "sm",
      "type": "submit"
    }
  }, [_vm._v("Search")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('navbar'), _vm._v("\n  This URL is in use for Andrea van Leerdam's PhD research project, 'Woodcuts as reading aids: Illustrations and knowledge transfer in printed books in Dutch on the natural world, c. 1480 - c. 1550', at Utrecht University, the Netherlands.\n  More information: "), _c('a', {
    attrs: {
      "href": "http://www.uu.nl/staff/aevanleerdam",
      "target": "_blank"
    }
  }, [_vm._v("www.uu.nl/staff/aevanleerdam")])], 1)
},staticRenderFns: []}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copies"
  }, [_c('navbar'), _vm._v(" "), _c('h1', [_vm._v("Copies")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.copies), function(copy) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(copy.Text))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(copy.Location))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(copy.Signature))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(copy.Consulted))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(copy.NumberOfUserstraces))])])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Text")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Signature")]), _vm._v(" "), _c('th', [_vm._v("Consulted")]), _vm._v(" "), _c('th', [_vm._v("# User traces")])])])
}]}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-illustrations"
  }, [_c('navbar'), _vm._v(" "), _c('h2', [_vm._v("Admin Illustration")]), _vm._v(" "), _c('ul', _vm._l((_vm.illustrations), function(illustration) {
    return _c('li', [_vm._v("\n      " + _vm._s(illustration.Subject) + " "), _c('b-button', {
      on: {
        "click": function($event) {
          _vm.open(illustration.Slug)
        }
      }
    }, [_vm._v("Edit")])], 1)
  })), _vm._v(" "), _c('b-button', {
    on: {
      "click": function($event) {
        _vm.newillustration()
      }
    }
  }, [_vm._v("Add")])], 1)
},staticRenderFns: []}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('h1', [_vm._v("Netherlandish Woodcuts")]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b-modal', {
    ref: "modalConfirm",
    attrs: {
      "id": "modalConfirm",
      "title": "Confirm",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": _vm.onclick
    },
    model: {
      value: (_vm.showmodal),
      callback: function($$v) {
        _vm.showmodal = $$v
      },
      expression: "showmodal"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b-modal', {
    ref: "modalPopup",
    attrs: {
      "id": "modalPopup",
      "title": _vm.titel,
      "ok-title": "Ok",
      "close-title": "Cancel"
    },
    on: {
      "ok": _vm.onclick,
      "cancel": _vm.cancelclick
    }
  }, [_vm._t("default", null, {
    data: _vm.data
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.copy) ? _c('div', {
    staticClass: "admin-copy"
  }, [_c('navbar'), _vm._v(" "), _c('confirm', {
    ref: "confirmdialog"
  }), _vm._v(" "), _c('h2', [_vm._v("Edit Copy \"" + _vm._s(_vm.copy.Signature) + "\"")]), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Edition"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copy.EditionId),
      expression: "copy.EditionId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.copy, "EditionId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.editions), function(e) {
    return _c('option', {
      domProps: {
        "value": e.Key
      }
    }, [_vm._v(_vm._s(e.Value))])
  }))]), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Location"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copy.LocationId),
      expression: "copy.LocationId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.copy, "LocationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.locations), function(l) {
    return _c('option', {
      domProps: {
        "value": l.Key
      }
    }, [_vm._v(_vm._s(l.Value))])
  }))]), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Consulted"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copy.ConsultedId),
      expression: "copy.ConsultedId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.copy, "ConsultedId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.consulted), function(c) {
    return _c('option', {
      domProps: {
        "value": c.Key
      }
    }, [_vm._v(_vm._s(c.Value))])
  }))]), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Signature"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Signature"
    },
    model: {
      value: (_vm.copy.Signature),
      callback: function($$v) {
        _vm.$set(_vm.copy, "Signature", $$v)
      },
      expression: "copy.Signature"
    }
  })], 1), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Remarks"
    }
  }, [_c('vue-editor', {
    attrs: {
      "id": "Remarks",
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.copy.Remarks),
      callback: function($$v) {
        _vm.$set(_vm.copy, "Remarks", $$v)
      },
      expression: "copy.Remarks"
    }
  })], 1), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Users Traces"
    }
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Users Trace")]), _vm._v(" "), _c('th', [_vm._v("Explanation")]), _vm._v(" "), _c('th', [_vm._v("Pertaining to")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.copy.Userstraces.Items), function(ut) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ut.UsersTrace))]), _vm._v(" "), _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(ut.ExplanationShort)
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ut.UsersTraceType))]), _vm._v(" "), _c('td', [_c('b-button', {
      on: {
        "click": function($event) {
          _vm.editUsersTrace(ut)
        }
      }
    }, [_vm._v("Edit")]), _c('b-button', {
      on: {
        "click": function($event) {
          _vm.deleteUsersTrace(ut)
        }
      }
    }, [_vm._v("Delete")])], 1)])
  }))]), _vm._v(" "), _c('b-button', {
    on: {
      "click": function($event) {
        _vm.addUsersTrace()
      }
    }
  }, [_vm._v("Add Users Trace")])], 1), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Links"
    }
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Url")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.copy.Links.Items), function(l) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(l.Description))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": l.Url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(l.Url))])]), _vm._v(" "), _c('td', [_c('b-button', {
      on: {
        "click": function($event) {
          _vm.editLink(l)
        }
      }
    }, [_vm._v("Edit")]), _c('b-button', {
      on: {
        "click": function($event) {
          _vm.deleteLink(l)
        }
      }
    }, [_vm._v("Delete")])], 1)])
  }))]), _vm._v(" "), _c('b-button', {
    on: {
      "click": function($event) {
        _vm.addLink()
      }
    }
  }, [_vm._v("Add Link")])], 1), _vm._v(" "), _c('popup', {
    ref: "popupUsersTrace",
    attrs: {
      "titel": "Users Trace",
      "data-vv-scope": "ut"
    },
    on: {
      "okclick": function($event) {
        _vm.beforeSaveUsersTrace();
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(popup) {
        return [(popup.data != null) ? _c('form', {
          attrs: {
            "data-vv-scope": "ut"
          }
        }, [_c('edit-full-width', {
          class: {
            'has-danger': _vm.errors.has('ut.UsersTrace')
          },
          attrs: {
            "caption": "Users Trace",
            "required": "true"
          }
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (popup.data.UsersTraceId),
            expression: "popup.data.UsersTraceId"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "UsersTrace"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(popup.data, "UsersTraceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, _vm._l((_vm.userstraces), function(ut) {
          return _c('option', {
            domProps: {
              "value": ut.Key
            }
          }, [_vm._v(_vm._s(ut.Value))])
        }))]), _vm._v(" "), _c('edit-full-width', {
          class: {
            'has-danger': _vm.errors.has('ut.UsersTraceType')
          },
          attrs: {
            "caption": "Pertaining to",
            "required": "true"
          }
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (popup.data.UsersTraceTypeId),
            expression: "popup.data.UsersTraceTypeId"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "UsersTraceType"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(popup.data, "UsersTraceTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, _vm._l((_vm.userstracetypes), function(utt) {
          return _c('option', {
            domProps: {
              "value": utt.Key
            }
          }, [_vm._v(_vm._s(utt.Value))])
        }))]), _vm._v(" "), _c('edit-full-width', {
          class: {
            'has-danger': _vm.errors.has('ut.Date')
          },
          attrs: {
            "caption": "Date",
            "required": "true"
          }
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (popup.data.DateId),
            expression: "popup.data.DateId"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "Date"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(popup.data, "DateId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, _vm._l((_vm.dates), function(d) {
          return _c('option', {
            domProps: {
              "value": d.Key
            }
          }, [_vm._v(_vm._s(d.Value))])
        }))]), _vm._v(" "), _c('edit-full-width', {
          class: {
            'has-danger': _vm.errors.has('ut.Language')
          },
          attrs: {
            "caption": "Language",
            "required": "true"
          }
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (popup.data.LanguageId),
            expression: "popup.data.LanguageId"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "Language"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(popup.data, "LanguageId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, _vm._l((_vm.languages), function(l) {
          return _c('option', {
            domProps: {
              "value": l.Key
            }
          }, [_vm._v(_vm._s(l.Value))])
        }))]), _vm._v(" "), _c('edit-full-width', {
          attrs: {
            "caption": "Explanation"
          }
        }, [_c('vue-editor', {
          attrs: {
            "id": "Explanation",
            "editorToolbar": _vm.customToolbar
          },
          model: {
            value: (popup.data.Explanation),
            callback: function($$v) {
              _vm.$set(popup.data, "Explanation", $$v)
            },
            expression: "popup.data.Explanation"
          }
        })], 1), _vm._v(" "), _c('b-alert', {
          attrs: {
            "variant": "danger",
            "show": _vm.errors.any()
          }
        }, [_vm._v("Errors")]), _vm._v(" "), _c('b-alert', {
          attrs: {
            "variant": "light",
            "show": !_vm.errors.any()
          }
        }, [_vm._v(" ")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_c('span', {
    staticClass: "col-md-12 text-right"
  }, [_c('b-alert', {
    attrs: {
      "variant": "success",
      "show": _vm.saved,
      "dismissible": ""
    },
    on: {
      "dismiss-count-down": _vm.countDownChanged,
      "dismissed": function($event) {
        _vm.saved = 0
      }
    }
  }, [_vm._v("Copy Saved")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": _vm.saving
    }
  }, [_vm._v("Saving......")]), _vm._v(" "), (!_vm.saving) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save(false)
      }
    }
  }, [_vm._v("Opslaan, Juffie")]) : _vm._e(), _vm._v(" "), (!_vm.saving) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save(true)
      }
    }
  }, [_vm._v("Opslaan en sluiten")]) : _vm._e(), _vm._v(" "), (!_vm.saving) ? _c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Annuleren")]) : _vm._e()], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[73]);


// WEBPACK FOOTER //
// static/js/app.626380685771ae5e1330.js